module.exports = __webpack_public_path__ + "static/media/alarm_gentle.24a71547.mp3";